import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { CareersRoutingModule } from './careers-routing.module';
import { CareersListComponent } from './careers-list/careers-list.component';
import { CareersCreateComponent } from './careers-create/careers-create.component';

@NgModule({
  declarations: [CareersListComponent, CareersCreateComponent],
  imports: [
    CommonModule,
    CareersRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class CareersModule { }
